import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver, checkLanguageCookie } from '../../utils/utils';

@Component({
  tag: 'resource-card',
  styleUrl: 'resource-card.css',
  shadow: true,
})
export class ResourceCard {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The button text
   */
  @Prop() buttonText: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Cards Data
   */
  @Prop() cardsData: string;

  /**
   * pagination
   */
  @Prop() pagination: string;

  /**
   * author
   */
  @Prop() author: string;

  /**
   * Index
   */
  @Prop() index: string;

  /**
   * Buttons Data
   */
  @Prop() buttonData: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;
  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }
  componentDidLoad() {
    this.adjustCardHeight();

    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.cards-wrapper '),
      () => {
        this.el.shadowRoot.querySelector('.cards-wrapper ').classList.add('animate');
      },
      ['.overlay1', '.overlay2', '.overlay3', '.overlay4', '.overlay5', '.overlay6'],
    );
  }

  adjustCardHeight() {
    // Card Height adjustments
    // Get all card-text-container elements
    const cardTextContainers = this.el.shadowRoot.querySelectorAll('.card-text-container');
    //console.log(cardTextContainers);
    // Get the height of the tallest card-text-container
    let maxHeight = 0;
    cardTextContainers.forEach((container: HTMLElement) => {
      const height = container.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Set the height of all card-text-container elements to the height of the tallest one
    cardTextContainers.forEach((container: HTMLElement) => {
      container.style.height = `${maxHeight}px`;
    });
  }

  render() {
    //console.log(this.cardsData)
    //const cards = JSON.parse(decodeURIComponent(this.cardsData));

    // function decodeHtml(html) {
    //   var txt = document.createElement('textarea');
    //   txt.innerHTML = html;
    //   return txt.value;
    // }

    // const decodedCardsData = decodeHtml(this.cardsData);
    // const cards = JSON.parse(decodedCardsData);
    const cards = typeof this.cardsData === 'string' ? JSON.parse(this.cardsData) : this.cardsData;
    const buttons = JSON.parse(this.buttonData);
    //console.log(buttons)
    const count = cards.length;

    // Get the language code from the cookie
    const langCode = checkLanguageCookie('wp-wpml_current_language');
    // Construct the href dynamically
    const href = langCode ? `/${langCode}/resource-center` : '/resource-center';

    return (
      <Host>
        <section class={` ${this.backgroundColor}`} style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
          <div class={` resource-card-container ${this.pagination && 'pagination'} ${this.author && 'author'} ${this.paddingBottom} ${this.paddingTop} ${this.textColor} `}>
            <div class={`w-full flex flex-col sm:flex-row justify-between items-center mb-32px`}>
              {this.mainTitle && <h2 class={` text-center fs-4 font-bold  text-ui-gray-1 ${this.textOrientation}`}>{this.mainTitle}</h2>}
              {buttons.length > 0 && buttons[0]['link'] !== undefined && (
                <div class="flex gap-12px mt-32px sm:mt-0">
                  {buttons.map(button => (
                    <button-block buttonsData={button}></button-block>
                  ))}
                </div>
              )}
            </div>
            <div class={`cards-wrapper ${this.pagination ? 'layout-pagination' : this.index ? 'layout-index' : `layout-${count}`} `}>
              {count > 0 &&
                cards.map(({ title, category, date, image_url, image_alt, link, description }, index) => {
                  // Add this line to clean the description
                  return (
                    <div class={`flex flex-col items-start justify-start text-start flex-grow rounded-xl card relative`}>
                      <div class={`overlay${index + 1}`}></div>
                      <div class="card-image-container relative overflow-hidden">{image_url && <img src={image_url} alt={image_alt} class={`card-image`} />}</div>
                      <div class={`  card-text-container`}>
                        {category && <p class={`text-ui-gray-2 fs--1 capitalize mb-8px`}>{category}</p>}
                        {title && <div class={`card-title`} innerHTML={title.replace(/\\u[\dA-Fa-f]{4}/g, '')}></div>}
                        {date && <p class={`text-ui-gray-3 fs--1 mt-8px`}>{date}</p>}

                        {/* {this.pagination && date && <p class={`text-ui-gray-2 fs--1 mt-8px`}>{date}</p>} */}
                        {this.pagination && description && (
                          // <div class={`text-ui-gray-2 fs--1 mt-8px line-clamp-3`} innerHTML={description}></div>
                          <div
                            class={`text-ui-gray-2 fs--1 mt-8px line-clamp-3`}
                            innerHTML={description
                              .replace(/\\u[\dA-Fa-f]{4}/g, '')
                              .replace(/â€˜/g, "'")
                              .replace(/â€™/g, "'")
                              .replace(/â€”/g, '-')}
                          ></div>
                        )}
                        {(this.pagination || this.index) && (
                          <div class="card-link">
                            {link && count > 1 ? <div class="card-link"></div> : <div></div>}
                            {(this.pagination || this.index) && <div></div>}
                          </div>
                        )}

                        {!this.pagination && !this.index && <div class="card-link"></div>}
                      </div>
                      <a class={`card-overlay`} href={link}></a>
                    </div>
                  );
                })}
              {cards.length < 5 && (!this.pagination || !this.index) && cards.length > 0 && (
                <div class={`view-more-card `}>
                  <div class={`lg:p-16px w-full group`}>
                    <h3 class={`text-medium-blue fs-0`}>{this.buttonText ? this.buttonText : 'View all 3E Resources'}</h3>
                    <a class={`card-overlay`} href={href}></a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
